export default __webpack_public_path__ + "static/grenova-quote-banner-4e426009db9781849a46fed941da3e83.jpg";